var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.984,
    height: 26.779,
    viewBox: "0 0 22.984 26.779",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(-2.75 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M3.5,16.9v-.277a4.549,4.549,0,0,1,.76-2.3A6.155,6.155,0,0,0,5.769,11.4c0-.842,0-1.7.074-2.539C6.223,4.8,10.232,2,14.193,2h.1c3.96,0,7.97,2.8,8.362,6.858.074.842,0,1.7.061,2.539a6.261,6.261,0,0,0,1.508,2.936,4.432,4.432,0,0,1,.76,2.286v.265a4.507,4.507,0,0,1-1.067,3.02,5.693,5.693,0,0,1-3.6,1.733,56.962,56.962,0,0,1-12.151,0,5.755,5.755,0,0,1-3.6-1.733A4.554,4.554,0,0,1,3.5,16.9Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#200e32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M9.555,20.852a3.9,3.9,0,0,0,5.419.638,3.651,3.651,0,0,0,.662-.638",
    transform: "translate(1.597 4.972)",
    fill: "none",
    stroke: "#200e32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.4f99aef7da819e0571700e0e5f26a1e1.svg";
export { ForwardRef as ReactComponent };